import axios from 'axios';
//Produzione  https://gestionale-scintilla.com/apis/v1/
export default (url = 'https://gestionale-scintilla.com/apis/v1/') => {
  return axios.create({
    baseURL: url,
    headers: { 'Access-Control-Allow-Origin': '*' },
  });
};
